// Post-payment cart clearing and order confirmation polish for published sites.

export default `
function snagcartOrderParams() {
  return new URLSearchParams(window.location.search || '');
}

function snagcartClearCartAfterPayment() {
  if (!window.WEBSITE_ID) return;
  try {
    var key = 'cart_' + window.WEBSITE_ID;
    window.cart = [];
    localStorage.setItem(key, '[]');
    localStorage.removeItem('snagcart_' + window.WEBSITE_ID);
  } catch (e) {}
  if (typeof updateCartUI === 'function') updateCartUI();
  if (typeof updateCartCount === 'function') updateCartCount();
  if (typeof renderCart === 'function') renderCart();
}

function snagcartCurrencySymbol(code) {
  if (code === 'INR') return '₹';
  if (code === 'EUR') return '€';
  if (code === 'GBP') return '£';
  return window.CURRENCY_SYMBOL || '$';
}

function snagcartFormatMoney(amount, currency) {
  var sym = snagcartCurrencySymbol(currency || 'USD');
  return sym + Number(amount || 0).toFixed(2);
}

async function snagcartCapturePayPalIfNeeded() {
  var params = snagcartOrderParams();
  var paypalToken = params.get('token');
  if (!paypalToken || !window.WEBSITE_ID || !window.API_URL) return null;
  var base = String(window.API_URL || '').replace(/\\/$/, '');
  try {
    var resp = await fetch(base + '/payments/' + window.WEBSITE_ID + '/paypal/capture', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ paypal_order_id: paypalToken }),
    });
    var data = await resp.json().catch(function() { return {}; });
    if (!resp.ok) throw new Error(data.detail || 'PayPal capture failed');
    return data;
  } catch (e) {
    if (typeof showNotification === 'function') showNotification((e && e.message) ? e.message : 'PayPal capture failed');
    return null;
  }
}

function snagcartRenderPublicOrder(order) {
  var loading = document.getElementById('confirmation-loading');
  var content = document.getElementById('confirmation-content');
  var error = document.getElementById('confirmation-error');
  if (!order) {
    if (loading) loading.style.display = 'none';
    if (content) content.style.display = 'none';
    if (error) error.style.display = 'block';
    return;
  }

  if (loading) loading.style.display = 'none';
  if (error) error.style.display = 'none';
  if (content) content.style.display = 'block';

  var currency = order.currency || 'USD';
  var orderNum = document.getElementById('order-number-display');
  if (orderNum) {
    orderNum.innerHTML = 'Order <strong>#' + (order.order_number || order.id || '').toString() + '</strong>'
      + (order.payment_status === 'paid' ? ' <span style="color:#16a34a;">· Paid</span>' : '');
  }

  var payBadge = document.getElementById('payment-status-badge');
  if (payBadge) {
    payBadge.textContent = order.payment_status === 'paid' ? 'Payment received' : 'Payment pending';
    payBadge.style.color = order.payment_status === 'paid' ? '#16a34a' : '#ca8a04';
  }

  var items = order.items || [];
  var list = document.getElementById('order-items-list');
  if (list) {
    list.innerHTML = items.map(function(item) {
      var qty = item.quantity || 1;
      var price = item.unit_price != null ? item.unit_price : (item.price || 0);
      var name = item.product_name || item.name || 'Item';
      return '<div style="display:flex;justify-content:space-between;gap:12px;padding:10px 0;border-bottom:1px solid #e2e8f0;">'
        + '<div><div style="font-weight:600;">' + name + '</div><div style="color:#64748b;font-size:.85rem;">Qty: ' + qty + '</div></div>'
        + '<div style="font-weight:700;">' + snagcartFormatMoney(price * qty, currency) + '</div></div>';
    }).join('');
  }

  var subtotal = order.subtotal != null ? order.subtotal : items.reduce(function(s, i) {
    return s + Number(i.unit_price || i.price || 0) * Number(i.quantity || 1);
  }, 0);
  var shipping = order.shipping_amount != null ? order.shipping_amount : 0;
  var tax = order.tax_amount != null ? order.tax_amount : 0;
  var total = order.total != null ? order.total : subtotal + shipping + tax;

  var subEl = document.getElementById('conf-subtotal');
  if (subEl) subEl.textContent = snagcartFormatMoney(subtotal, currency);
  var shipEl = document.getElementById('conf-delivery');
  if (shipEl) shipEl.textContent = Number(shipping) === 0 ? 'Free' : snagcartFormatMoney(shipping, currency);
  var taxEl = document.getElementById('conf-tax');
  if (taxEl) taxEl.textContent = snagcartFormatMoney(tax, currency);
  var totalEl = document.getElementById('conf-total');
  if (totalEl) totalEl.textContent = snagcartFormatMoney(total, currency);

  var addr = document.getElementById('conf-address');
  if (addr) {
    addr.innerHTML = '<strong>' + (order.customer_name || 'Customer') + '</strong><br>'
      + (order.customer_email || '')
      + (order.payment_method ? '<br><span style="color:#64748b;">Paid via ' + order.payment_method + '</span>' : '');
  }
}

async function snagcartLoadPublicOrder() {
  var params = snagcartOrderParams();
  var page = params.get('page') || '';
  var onConfirmation = page === 'order-confirmation'
    || document.querySelector('[data-section-name="order-confirmation"]')
    || document.getElementById('confirmation-content');
  if (!onConfirmation) return;

  var paymentSuccess = params.get('payment') === 'success' || params.get('session_id') || params.get('token');
  if (paymentSuccess) snagcartClearCartAfterPayment();

  await snagcartCapturePayPalIfNeeded();

  var orderId = params.get('order_id');
  if (!orderId || !window.WEBSITE_ID || !window.API_URL) {
    if (!orderId && onConfirmation) snagcartRenderPublicOrder(null);
    return;
  }

  var base = String(window.API_URL || '').replace(/\\/$/, '');
  try {
    var resp = await fetch(base + '/storefront/' + window.WEBSITE_ID + '/orders/' + encodeURIComponent(orderId));
    var order = await resp.json().catch(function() { return null; });
    if (!resp.ok) throw new Error((order && order.detail) || 'Order not found');
    snagcartRenderPublicOrder(order);
    if (order.payment_status === 'paid' || params.get('payment') === 'success') snagcartClearCartAfterPayment();
  } catch (e) {
    snagcartRenderPublicOrder(null);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', snagcartLoadPublicOrder);
} else {
  snagcartLoadPublicOrder();
}
`;
